export default function choiceSetsWithQuantities(
  choiceSets: ChoiceSet[],
  choiceSelections: ChoiceSelections,
  parentPath?: string,
  miam?: MiamStagedPurchase,
): ChoiceSetWithQuantity[] {
  const ret = choiceSets?.map(choiceSet => {
    if (choiceSet?.displayType === 'makeameal') {
      return miamChoiceSetWithQuantities(choiceSet, parentPath || '', miam);
    }
    return {
      ...choiceSet,
      choices: choiceSet?.choices
        ?.filter(c => c)
        .map((choice: any) => {
          // (because we added the checkbox display type feature quite late)
          // this hack kind of un-nests the nested selections from the make it a meal choice set
          // so that the function can understand it
          // const checkboxSubItemSelections = ;
          // didn't actually do this hack but left the comments, ignore last 4 lines
          const quantity =
            choice?.quantity ||
            // choiceSelections[nested === 2 ? choiceSet.key : choiceSet.id] || []
            (
              choiceSelections[choiceSet.key] ||
              choiceSelections[choiceSet.id] ||
              []
            )?.filter(
              // super dodgy, this 'object' type check is there because of differences in choice selection data structures.
              // TODO: refactor everything, why are nested choice sets handled any differently than normal choice sets?
              selection =>
                typeof selection === 'string'
                  ? selection === choice?.id
                  : (selection as ChoiceWithQuantity)?.id === choice?.id,
            ).length;

          return {
            ...choice,
            quantity,
            moneyPrice: choice.baseMoneyPrice,
          };
        }),
    };
  });
  return ret;
}

//make choiceset with quantities function recursively
const miamChoiceSetWithQuantities = (
  choiceSet: ChoiceSet,
  parentPath: string,
  miam?: MiamStagedPurchase,
): ChoiceSetWithQuantity => {
  return {
    ...choiceSet,
    choices: choiceSet?.choices?.map((choice: any) => {
      const uniqKey = parentPath
        ? `${parentPath}.${choiceSet.key}`
        : choiceSet.key;
      let quantity = (miam || {})[uniqKey]?.quantity || choice?.quantity || 0;

      const selections =
        //@ts-ignore
        uniqKey in (miam || {})
          ? //@ts-ignore
            ((((miam[uniqKey]?.selections || {}) as SDict<
              SDict<ChoiceWithQuantity[]>
            >) || {})[uniqKey] as SDict<ChoiceWithQuantity[]>)
          : undefined;
      if (
        'choiceSets' in choice &&
        choice.choiceSets.length > 0 &&
        selections
      ) {
        const choiceSets = choiceSetsWithQuantitiesV2(
          choice.choiceSets,
          selections,
        );

        return {
          ...choice,
          quantity,
          choiceSets,
          moneyPrice: choice.baseMoneyPrice,
        };
      } else {
        return {
          ...choice,
          quantity,
          moneyPrice: choice.baseMoneyPrice,
        };
      }
    }),
  };
};

function choiceSetsWithQuantitiesV2(
  choiceSets: ChoiceSet[],
  choiceSelections: SDict<ChoiceWithQuantity[]>,
): ChoiceSetWithQuantity[] {
  const ret = choiceSets?.map(choiceSet => {
    return {
      ...choiceSet,
      choices: choiceSet?.choices?.map((choice: any) => {
        if (!choice?.choiceSets || (choice?.choiceSets || []).length === 0) {
          const quantity =
            choice?.quantity ||
            (
              choiceSelections[choiceSet.key] ||
              choiceSelections[choiceSet.id] ||
              []
            )?.filter(selection => selection === choice?.id).length;

          return {
            ...choice,
            quantity,
            moneyPrice: choice.baseMoneyPrice,
          };
        } else choiceSetsWithQuantitiesV2(choice.choiceSets, choiceSelections);
      }),
    };
  });
  return ret;
}
